import Vue from 'vue'
import YtVue from './YtVue'
import router from './router'
import Antd from 'ant-design-vue'
import store from './store'
import request from 'utils/request'
import db from 'utils/localstorage'
import AesEncrypt from 'utils/aesEncrypt'
import Icon from 'utils/YtIcon'
import VueMeta from 'vue-meta'
import 'ant-design-vue/dist/antd.css'
import * as echarts from 'echarts'
import 'utils/install'
import 'utils/my.less'

import VueI18n from 'vue-i18n'
import LangENUS from './i18n/langs/en-us'
import LangZHCN from './i18n/langs/zh-cn'

// 替换窗口图标
if (window.location.href.includes('hdppe') || +db.get('Hide_Company_Info') === 1) {
  db.save('Hide_Company_Info', 1)
  var link = document.querySelector('link[rel*="icon"]')
  link.href = 'static/img/favicon2.ico'
}

Vue.config.productionTip = false
Vue.use(Antd)
Vue.use(db)
Vue.use(VueMeta)
Vue.use(VueI18n)
Vue.prototype.$echarts = echarts
Vue.use({
  install (Vue) {
    Vue.prototype.$db = db
  }
})

const i18n = new VueI18n({
  locale: db.get('language') || 'zh-cn',
  messages: {
    'en-us': LangENUS,
    'zh-cn': LangZHCN
  }
})

/**
     * 随机生成三位数
     * @returns {boolean}
     */
Vue.prototype._mathRandom1000 = function () {
  return (Math.random() * 1000).toFixed(0) * 1
}

Vue.prototype.$post = request.post
Vue.prototype.$get = request.get
Vue.prototype.$put = request.put
Vue.prototype.$delete = request.delete
Vue.prototype.$export = request.export
Vue.prototype.$download = request.download
Vue.prototype.$upload = request.upload
Vue.prototype.$originalGet = request.originalGet
Vue.prototype.$aesEncrypt = AesEncrypt
Vue.prototype.$checkIsNotNull = function checkIsNotNull (value) {
  if (value === '' || value === undefined || value === null) {
    return false
  } else {
    return true
  }
}

// 注册组件
Vue.component('yt-icon', Icon)

/* eslint-disable no-new */
new Vue({
  i18n,
  router,
  store,
  render: h => h(YtVue)
}).$mount('#ytvue')



// WEBPACK FOOTER //
// ./src/main.js